import type {BootstrapHelpItem} from '@app/core/interfaces';
import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {HelpModeType} from "../models/help-mode.type";

@Injectable({
  providedIn: 'root'
})
export class HelpService {
  private $helpItems!: BootstrapHelpItem[];

  private selectedHelp: BehaviorSubject<BootstrapHelpItem | undefined> = new BehaviorSubject<BootstrapHelpItem  | undefined>(undefined)
  selectedHelp$: Observable<BootstrapHelpItem  | undefined> = this.selectedHelp.asObservable();


  selectHelp(data : BootstrapHelpItem | undefined){
    this.selectedHelp.next(data)
  }

  get helpItems() {
    return this.$helpItems;
  }

  set helpItems(items) {
    this.$helpItems = items;
  }

  private $helpId!: number;

  get helpId() {
    return this.$helpId;
  }

  set helpId(id) {
    this.$helpId = id;
  }

  constructor() { }
}
